<div class="row d-flex flex-row justify-content-between mt-5">
  <div class="col pb-4 pb-md-0">
    <base-search
      class="d-block mw-100 max-w-md-500px"
      placeholder="search.general"
      [value]="activatedRoute.snapshot.queryParams.search"
      [useEnterEvent]="true"
      (query)="onSearchChange($event)"
    ></base-search>
  </div>
  <div class="col-md-auto d-flex justify-content-end">
    <base-action-dropdown
      *ngIf="!isWorkCouncil"
      label="action.export"
      color="dark"
      [items]="['workingContracts', 'administration.operationalInformation']"
      (listItemClicked)="handleClick($event)"
    ></base-action-dropdown>
  </div>
</div>
